module.exports = __webpack_public_path__ + "img/source.73061631.png";